module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fm"
  }, [_vm._v("Doubt is not a pleasant mental state")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("but certainty is a ridiculous one.")]), _vm._v(" "), _c('p', {
    staticClass: "fm4"
  }, [_vm._v("—V"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("OLTAIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "fm3"
  }, [_vm._v("To die for an idea")]), _vm._v(" "), _c('p', {
    staticClass: "fm1"
  }, [_vm._v("is to pay a high price for conjecture.")]), _vm._v(" "), _c('p', {
    staticClass: "fm2"
  }, [_vm._v("—A"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("NATOLE")]), _vm._v(" F"), _c('span', {
    staticClass: "smallcaps"
  }, [_vm._v("RANCE")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-617a3729","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/frontmatter01.vue
// module id = 72
// module chunks = 0